function getCurrentSetup(packLine) {
    return packLine?.currentSetup ?? packLine?.current_setup ?? '';
}

export function isPcdataLine(packLine) {
    return getCurrentSetup(packLine).startsWith('pcdata_');
}

export function isPcdata20Line(packLine) {
    return getCurrentSetup(packLine) === 'pcdata_2.0';
}

export function getPcdataSetupLabel(packLine) {
    return getCurrentSetup(packLine) || 'pcdata';
}

export function getDisplayLineNumber(packLine) {
    if (isPcdataLine(packLine)) {
        return packLine.mlpLineNumber ?? packLine.mlp_line_number ?? packLine.lineNumber;
    }
    return packLine.lineNumber;
}

export function compareDisplayLineNumbers(a, b) {
    const aLabel = String(getDisplayLineNumber(a));
    const bLabel = String(getDisplayLineNumber(b));

    return aLabel.localeCompare(bLabel, undefined, { numeric: true, sensitivity: 'base' });
}
